import React, { Component } from 'react'
import IconButton from 'material-ui/IconButton'
import EditIcon from 'material-ui/svg-icons/editor/mode-edit'
import Paper from 'material-ui/Paper'
import { FormattedMessage } from 'react-intl'
import Modal from '../../routes/Contacts/ListName/Modals'

export default class CreateListCard extends Component {
  state = {
    open: false,
    listModalPurpose: null
  }

  handleAddList = () => {
    this.setState({open: true, listModalPurpose: 'create-list'})
  }

  handleClose = () => {
    this.setState({open: false})
  }

  render () {
    return (
      <div className={`dib ${this.props.className}`}>
        <Paper
          className={`image-contact flex justify-center items-center`}
          circle
          style={{backgroundColor: '#CBD2DB', width: 185, height: 185}}>
          <div className='flex justify-center items-center h-100'>
            <IconButton
              onTouchTap={this.handleAddList}
              style={{width: 190, height: 190}}
              iconStyle={{width: 80, height: 80, fill: '#FFFFFF'}}>
              <EditIcon/>
            </IconButton>
          </div>
          <Modal
            location={this.props.location}
            createContactList={this.props.createContactList}
            purpose={this.state.listModalPurpose}
            open={this.state.open}
            handleClose={this.handleClose}/>
        </Paper>
        <div className='tc pt3' style={{fontSize: 14, color: '#6B7C93'}}>
          <FormattedMessage id='contacts.create'/>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ContactList/CreateListCard.js